export const filterNull = <T>(array: T[]) => {
  return array.filter(it => it !== null)
}
